:host {
    display: block;
    font-family: soleil, sans-serif;
    font-weight: normal;
    font-style: normal;
    line-height: 1.4em;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

:host(.body__1) {
    font-size: 16px;
}

:host(.body__2) {
    font-size: 14px;
}
